import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const conditions = ['Parkinson idiopático', 'Parkinsonismos atípicos', 'Temblor esencial', 'Demencia con Cuerpos de Lewy', 'PSP y AMS', 'Deterioro cognitivo leve', 'Disfagia leve-moderada', 'Inestabilidad postural', 'Freezing de la marcha', 'Síndrome del cuidador'];
export const Conditions = () => {
  return <section className="py-10 md:py-16 bg-cream border-b border-gray-200" data-id="element-65">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-66">
        <h3 className="text-base md:text-2xl font-bold text-navy mb-4 md:mb-8 max-w-2xl mx-auto leading-snug" data-id="element-67">
          Funciona desde hoy en el domicilio de tu próximo paciente con
          Parkinson.
        </h3>

        <p className="text-[11px] md:text-sm text-gray-500 uppercase tracking-wider font-bold mb-4 md:mb-6" data-id="element-68">
          Condiciones incluidas:
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 md:gap-3" data-id="element-69">
          {conditions.map((cond, i) => <div key={i} className="flex items-center gap-1.5 md:gap-2 bg-white px-2.5 md:px-4 py-1.5 md:py-2 rounded-lg border border-gray-200 shadow-sm hover:border-teal/30 hover:shadow transition-all" data-id="element-70">
              <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-teal flex-shrink-0" data-id="element-71" />
              <span className="text-gray-700 font-medium text-xs md:text-sm" data-id="element-72">
                {cond}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};